module.exports = __webpack_public_path__ + "static/media/Pastry Cream & Custard-min.80c1d552.jpg";